import { useStaticQuery, graphql } from 'gatsby';
import isEmpty from 'lodash/isEmpty';

export const useActiveJobOfferts = (): boolean => {
  const { allElevatoApiItemsEn } = useStaticQuery(
    graphql`
      query {
        allElevatoApiItemsEn {
          nodes {
            elevatoId
          }
        }
      }
    `
  );
  return !isEmpty(allElevatoApiItemsEn.nodes);
};
